import { drawerAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { Display, displayCloseButton, getDialogPadding, getFooterMargin, } from "../helper";
import { textStyles, colors } from "../../../../theme/foundations/generated";
import { DrawerVariant } from "../Drawer.types";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([...parts.keys, "button"]);
const OPACITY = 0.9;
const colorConverter = (colorInHexValue) => `${colorInHexValue}${Math.round(OPACITY * 255).toString(16)}`;
const baseStyle = definePartsStyle(({ display, colorTitle }) => ({
    dialog: Object.assign({ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start" }, getDialogPadding(display)),
    overlay: {
        background: colorConverter(colors.semantic.brand.primary),
    },
    header: Object.assign({ display: "flex", alignItems: "center", justifyContent: "center", columnGap: ".5rem", padding: 0, margin: "0 0 2.5rem", color: colorTitle || "semantic.text.primary" }, (display === Display.MOBILE
        ? textStyles.subtitle.desktopMain
        : textStyles.title.desktopMain)),
    button: Object.assign({ position: "absolute", height: "none", minWidth: "none", padding: 0, margin: 0, _hover: {
            background: "none",
        } }, displayCloseButton(display)),
    body: {
        padding: 0,
        margin: 0,
        flex: "none",
    },
    footer: Object.assign({ flex: "none", padding: 0 }, getFooterMargin(display)),
}));
const variants = {
    [DrawerVariant.DEFAULT]: definePartsStyle({}),
    [DrawerVariant.SIDE_PANEL]: definePartsStyle({
        dialog: {
            padding: "0",
        },
        header: Object.assign({ margin: 0, borderBottom: "1px solid", borderColor: " semantic.border.secondary", padding: "24px 16px", width: "100%" }, textStyles.title.mobileCard),
    }),
    [DrawerVariant.FULL_CONTENT]: definePartsStyle({
        dialog: {
            padding: 0,
        },
        header: {
            margin: 0,
            padding: 0,
            width: "100%",
        },
    }),
};
const sizes = {
    half: {
        dialog: {
            maxW: "50%",
        },
    },
};
const DrawerTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes,
    defaultProps: {
        variant: DrawerVariant.DEFAULT,
    },
});
export default DrawerTheme;
//# sourceMappingURL=Drawer.default.js.map